import React, { useState } from 'react'
import { Button, Typography, Input, Space, notification, Select, Switch, Divider } from 'antd';
import './styles.less'
import { useDispatch } from 'react-redux';
import { Form } from 'antd';
import Request from '../../request';
import { push } from 'connected-react-router';
import { ArrowRightOutlined } from '@ant-design/icons';
import _ from 'lodash'
import { isNormalInteger } from '../../utils';
import { ReactComponent as ImageThumb } from '../../assets/LoginPage.svg'
import ForgotPassword from './ForgotPassword'
const { Text } = Typography
const { Option } = Select

const Login = () => {
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const [loader, setLoader] = useState(false)
    const [login, setLoginRun] = useState(true)
    const [forgotPassWord, setForgotPassword] = useState(false)

    const onFinish = async (valData) => {
        const { mobile } = valData
        setLoader(true)
        let { user, token, success, message: loginMessage, data } = await Request.login(valData)
        if (success) {
            dispatch({
                type: 'SET_AUTH_TOKEN',
                payload: data.auth_token
            })
            Request.getProfile().then(({ error, data: profileData, message }) => {
                if (!error && profileData) {
                    var profileData = { ...profileData, message }
                    dispatch({
                        type: 'SET_CURRENT_USER',
                        payload: { ...profileData }
                    })
                    dispatch(push('/dashboard'))
                    notification.success({
                        message: loginMessage
                    })

                } else {
                    notification.error({
                        message: message || "Failed"
                    })
                }
            })

        }
        else {
            notification.error({
                message: loginMessage || "Failed"
            })
        }
        setLoader(false)
    }

    const requiredRule = [{ required: true, message: 'Please input field' }]

    return (
        <div className="LoginParentDiv">
            <div className="LoginSubDiv">
                <div className="LeftSubDiv">
                    <div className="loginPageCustomer">
                        # Super Admin Login Portal !
                    </div>
                    <ImageThumb height="50vh" />
                </div>
            </div>
            <div className='loginWrapper'>
                <div className='loginContainer' style={{ alignItems: "center" }}>
                    <Divider>
                        <div className="superadmin" >Enter Credentials </div>
                    </Divider>
                    <div className="displayFlex" style={{ alignItems: "center" }}>
                        <div >
                            <Form className='form' form={form} onFinish={onFinish} size='large'>
                                <div className='inputWidth marginTop'>
                                    <Form.Item name='email' rules={requiredRule}>
                                        <Input type="email" placeholder='Enter Email ID' />
                                    </Form.Item>
                                    <Form.Item name='password' rules={requiredRule}>
                                        <Input maxLength={16} type="password" placeholder='Enter Password' />
                                    </Form.Item>
                                </div>
                                <Form.Item >
                                    <Button size='large' loading={loader} htmlType='submit' type='primary' style={{ width: 'clamp(2rem, 20rem, 22rem)', maxWidth: '80%', marginTop: '3rem' }}>Sign in</Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login